import { createContext, useContext } from 'react';
import _noop from 'lodash/noop';

export type TabCountersContextValue = {
  /**
   * Refetches the query that feeds the tab-bar counters of the surrounding tab
   * shell. Call it from a tab container after a mutation whose response can't
   * repair the counter on its own. No-op outside of a provider.
   */
  refetchCounters: () => void;
};

const TabCountersContext = createContext<TabCountersContextValue>({
  refetchCounters: _noop,
});

export const useTabCountersContext = () => useContext(TabCountersContext);

export default TabCountersContext;
